<template>
    <div class="account-area">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="account-content">
                        <div class="account-header">
                            <router-link to="/">
                                <img src="../../assets/images/logo.png" height="150" width="150" alt="main-logo">
                            </router-link>
                            <h3>Esqueceu a senha?</h3>
                        </div>

                        <!-- Mensagem de sucesso -->
                        <div v-if="successMessage" class="alert-success">
                            <span>{{ successMessage }}</span>
                        </div>

                        <!-- Mensagem de erro -->
                        <div v-if="errorMessage" class="alert-error">
                            <span>{{ errorMessage }}</span>
                        </div>

                        <form v-if="!successMessage" @submit.prevent="handleForgotPassword" class="account-wrap">
                            <p class="form-hint">
                                Insira o seu email e enviaremos um link para redefinir a sua senha.
                            </p>
                            <div class="form-group mb-24 icon">
                                <input
                                    v-model="email"
                                    type="email"
                                    class="form-control"
                                    placeholder="Email"
                                    required
                                    :disabled="loading"
                                >
                                <img src="../../assets/images/icon/sms.svg" alt="sms">
                            </div>
                            <div class="form-group mb-24">
                                <button type="submit" class="default-btn" :disabled="loading">
                                    <span v-if="loading" class="btn-spinner"></span>
                                    <span v-else>Enviar link de recuperação</span>
                                </button>
                            </div>
                            <div class="form-group mb-24 text-center">
                                <router-link to="/login" class="forgot">Voltar ao login</router-link>
                            </div>
                        </form>

                        <!-- Estado após envio bem-sucedido -->
                        <div v-if="successMessage" class="text-center mt-3">
                            <router-link to="/login" class="default-btn" style="display:inline-block; padding: 15px 30px;">
                                Voltar ao login
                            </router-link>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import authService from '../../services/authService';

export default {
    name: 'ForgetPasswordPage',

    data() {
        return {
            email: '',
            loading: false,
            successMessage: '',
            errorMessage: '',
        };
    },

    methods: {
        async handleForgotPassword() {
            this.successMessage = '';
            this.errorMessage = '';
            this.loading = true;
            try {
                const result = await authService.forgotPassword(this.email);
                this.successMessage = result.message || 'Se o email existir nos nossos registos, receberá um link de recuperação em breve.';
            } catch {
                this.errorMessage = 'Erro ao processar o pedido. Tente novamente mais tarde.';
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss">
.account-area {
	background-image: url(../../assets/images/account-bg.jpg);
	background-position: center center;
	background-repeat: no-repeat;
	background-size: auto;
	height: 100vh;
}
.account-content {
	max-width: 510px;
	margin: auto;
	background-color: var(--white-color);
	border-radius: 30px;
	padding: 50px;
}
.account-header {
	text-align: center;
	img {
		margin-bottom: 30px;
	}
	h3 {
		margin-bottom: 30px;
		padding-top: 30px;
		border-top: 1px solid #EBF1FF;
		font-size: 20px;
	}
}
.account-wrap {
	.forgot {
		color: #1765FD;
		font-size: 14px;
	}
	.default-btn {
		color: var(--white-color);
		width: 100%;
		padding: 23px 20px;
	}
	.account {
		font-size: 14px;
		margin-bottom: 0;
		color: #292D32;
		a {
			color: #1765FD;
		}
	}
	.form-check {
		a {
			color: #1765FD;
		}
	}
}
.account-social-link {
	padding-left: 0;
	margin-bottom: 0;
	list-style-image: none;
	text-align: center;
	li {
		display: inline-block;
		margin-right: 15px;
		&:last-child {
			margin-right: 0;
		}
		a {
			width: 46px;
			height: 46px;
			line-height: 50px;
			text-align: center;
			display: inline-block;
			background-color: #EBF1FF;
			color: #1765FD;
			border-radius: 50%;
			font-size: 20px;
			&:hover {
				background-color: var(--main-color);
				color: var(--white-color);
			}
		}
	}
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .account-area {
        height: 100%;
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .account-content {
        padding: 30px;
    }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
    .account-area {
        height: 100%;
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .account-content {
        padding: 30px;
    }
}

/* Min width 1320px to Max width 1550px */
@media only screen and (min-width: 1320px) and (max-width: 1550px) {
    .account-area {
        height: 100%;
        padding-top: 50px;
        padding-bottom: 50px;
    }

}

/* Hints e alertas */
.form-hint {
    font-size: 14px;
    color: #7a7a7a;
    margin-bottom: 20px;
    text-align: center;
}
.alert-error {
    background-color: #FFF0F0;
    border: 1px solid #FFCDD2;
    color: #C62828;
    border-radius: 10px;
    padding: 12px 16px;
    margin-bottom: 20px;
    font-size: 14px;
}
.alert-success {
    background-color: #F0FFF4;
    border: 1px solid #C8E6C9;
    color: #2E7D32;
    border-radius: 10px;
    padding: 12px 16px;
    margin-bottom: 20px;
    font-size: 14px;
}

/* Spinner no botão */
.btn-spinner {
    display: inline-block;
    width: 18px;
    height: 18px;
    border: 2px solid rgba(255,255,255,0.4);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
}
@keyframes spin {
    to { transform: rotate(360deg); }
}
</style>